import { Button } from "@pinkyhead/dovekit";
import { BackButton } from "../../../../common/BackButton"
import { ParticipationsLoading } from "../../../../modules/LoadingPlaceholders/ParticipationsLoading";
import { NoParticipation } from "../../../../modules/NoDataPlaceholders/NoParticipation";
import { ParticipationCardDoctor } from "../../../../modules/Participation/ParticipationCardDoctor";
import { ParticipationRow } from "../../../../modules/Participation/ParticipationRow";
import { HeaderContainer } from "../../Details.styles";
import { useParticipations } from "./Participations.hooks";
import { SectionTitle, ListContainer } from "./Participations.styles";
import { AppNames } from "./utils";

export const Participations = () => {
  const {
    handleTabChange,
    askADoctorData,
    doveHubData,
    doveCommunitiesData,
    showAllParticipations
  } = useParticipations();
  return (
    <div>
      <HeaderContainer>
        <BackButton onClick={() => handleTabChange({ id: 0 })} />
        <h3>All Participations</h3>
      </HeaderContainer>
      <ListContainer className="margin-top">
        {(!askADoctorData.data && askADoctorData.isLoading)
          ? <ParticipationsLoading />
          : askADoctorData.data
            ?
              <ListContainer>
                <SectionTitle>Ask a Doctor</SectionTitle>
                <ParticipationCardDoctor data={askADoctorData.data} />
              </ListContainer>
            : null
        }
        {(doveHubData.isLoading && doveHubData.data.count === 0)
          ? <ParticipationsLoading />
          : doveHubData.data.count > 0
            ?
              <ListContainer>
                <SectionTitle>DoveHubs Joined</SectionTitle>
                {doveHubData.data.results.slice(0, 3).map((each, index) => (
                  <ParticipationRow data={each} key={index} />
                ))}
                {doveHubData.data.count > 3 &&
                  <Button
                    size="small"
                    variant="tertiary"
                    fullWidth
                    onClick={() => showAllParticipations({ 
                      name: "Participations in DoveHub", 
                      url: doveHubData.url,
                      appName: AppNames.dovehub
                    })}
                  >Show more</Button>
                }
              </ListContainer>
            : null
          }
        {(doveCommunitiesData.isLoading && doveCommunitiesData.data.count === 0)
          ? <ParticipationsLoading />
          : doveCommunitiesData.data.count > 0
          ?
          <ListContainer>
                <SectionTitle>DoveCommunities Joined</SectionTitle>
                {doveCommunitiesData.data.results.slice(0, 3).map((each, index) => (
                  <ParticipationRow data={each} key={index} />
                ))}
                {doveCommunitiesData.data.count > 3 &&
                  <Button
                    size="small"
                    variant="tertiary"
                    fullWidth
                    onClick={() => showAllParticipations({
                      name: "Participations in DoveCommunities",
                      url: doveCommunitiesData.url,
                      appName: AppNames.community
                    })}
                  >Show more</Button>
                }
              </ListContainer>
            : null
        }
        {(
          !askADoctorData.data && !askADoctorData.isLoading &&
          !doveHubData.data && !doveHubData.isLoading &&
          !doveCommunitiesData.data && !doveCommunitiesData.isLoading
        ) &&
          <NoParticipation />
        }
      </ListContainer>
    </div>
  )
}
